module.exports = __webpack_public_path__ + "static/media/location.4e054d7b.svg";